import React from 'react'
import OrganizationInfo from 'src/app/OrganizationInfo/OrganizationInfo'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { organizationInfoRouteProps } from 'src/navigation/routeProps'

const OrganizationInfoAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsOrganizationInfo,
  routeProps: organizationInfoRouteProps,
  component: <OrganizationInfo />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default OrganizationInfoAppRoute
